import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import { useTeamContext } from "store/contexts/teamContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import Button from "components/CustomButton";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { useGlobalContext } from "store/contexts/globalContext";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import { useHistory } from "react-router-dom";

var styles = {
  relative: {
    position: "relative",
  },
  titleDailog: {
    display: "flex",
    justifyContent: "center",
    fontWeight: "600",
    marginBottom: "0",
    paddingBottom: "15px",
  },
  headingDailog: {
    padding: "20px 0 15px",
  },
  selectMember: {
    border: "1px solid #00000042",
    padding: "10px",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  boxShadow: {
    background: "white",
    marginTop: "10px",
    borderRadius: "5px",
    boxShadow: "0 8px 23px 0 rgb(0 0 0 / 22%), 0 1px 3px 0 rgb(0 0 0 / 46%)",
  },
  memberList: {
    display: "flex",
    flexDirection: "column",
    listStyle: "none",
  },
  displayMember: {
    padding: "10px 5px",
  },
  actionButton: {
    paddingTop: "120px",
  },
  closeIcon: {
    width: "20px",
    height: "20px",
    position: "absolute",
    top: "0px",
    right: "0px",
    cursor: "pointer",
  },
};

export default ({ user, showSelectAdminModal, closeSelectAdminModal }) => {
  const classes = styles;
  const { deleteTeam } = useGlobalContext();
  const history = useHistory();
  const { team } = useTeamContext();
  const [teamMembers, setTeamMembers] = useState([]);
  const [selectMember, setSelectMember] = useState(null);
  const [showMembers, setShowMembers] = useState(null);
  const [changeRole] = useState(2);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!showSelectAdminModal) {
      return;
    }

    setTeamMembers(team.members.filter((member) => member?.id !== user?.id));

    //eslint-disable-next-line
  }, [showSelectAdminModal]);

  useEffect(() => {
    if (!showSelectAdminModal && teamMembers.length === 0) {
      return;
    }

    setSelectMember(teamMembers[0]);
  }, [showSelectAdminModal, teamMembers]);

  const showMembersPooper = (event) => {
    setShowMembers(event.currentTarget);
  };

  const hideMembersPooper = () => {
    setShowMembers(null);
  };

  const updateSelectMember = (member, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSelectMember(member);
    hideMembersPooper();
  };

  const selectSuperAdmin = async () => {
    setLoading(true);
    try {
      await Promise.all([
        await TeamService.postChangeUserRole(
          team?.id,
          selectMember?.id,
          changeRole
        ),
        await TeamService.postTeamLeave(team?.id),
      ]);
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
    closeSelectAdminModal();
    history.push("/");
    deleteTeam(team);
  };

  return (
    <Modal
      classNames={{ modalContainer: "modalContainer", modal: "adminModal" }}
      open={showSelectAdminModal}
      showCloseIcon={false}
      onClose={closeSelectAdminModal}
    >
      <div style={classes.relative}>
        <h4 style={classes.titleDailog}>Make Super Admin</h4>
        <div style={classes.closeIcon}>
          <CloseIcon onClick={closeSelectAdminModal} />
        </div>
        <hr className="dropDownDivider" />
        <h6 style={classes.headingDailog}>Please select a Premium Member</h6>
        <div>
          <div style={classes.selectMember} onClick={showMembersPooper}>
            {selectMember?.full_name}
            <div>
              {Boolean(!showMembers) && <FontAwesomeIcon icon={faSortDown} />}
              {Boolean(showMembers) && <FontAwesomeIcon icon={faSortUp} />}
            </div>
          </div>
          <CSSTransition
            in={Boolean(showMembers)}
            timeout={300}
            unmountOnExit
            classNames="admin-element"
          >
            <ClickAwayListener onClickAway={hideMembersPooper}>
              <div style={classes.boxShadow} className="show-member-list">
                <ul
                  style={classes.memberList}
                  className="adminSelectMemberList"
                >
                  {teamMembers?.map((member) => (
                    <li
                      key={member?.id}
                      style={classes.displayMember}
                      onClick={(e) => updateSelectMember(member, e)}
                    >
                      {member?.full_name}
                    </li>
                  ))}
                </ul>
              </div>
            </ClickAwayListener>
          </CSSTransition>
        </div>
        <div style={classes.actionButton}>
          <Button
            onClick={selectSuperAdmin}
            name={
              !loading ? "Make Super Admin" : <Loader width={25} height={25} />
            }
            disabled={loading && true}
          />
        </div>
      </div>
    </Modal>
  );
};
